/**
 *
 * H1
 *
 */

import styled from 'styled-components';
import { colors } from 'globalStyles';

const H1 = styled.h1`
  font-size: 36px;
  line-height: 44px;
  letter-spacing: -1px;
  margin: 0;
  color: ${colors.MENU};
  font-family: poppins, sans-serif;
`;

export default H1;



// WEBPACK FOOTER //
// ./src/components/H1/index.js